export const getDateTime = () => {
    const currentDateTime = new Date();

    const options = {
        hour: '2-digit',
        minute: '2-digit',
    };

    const time = currentDateTime.toLocaleTimeString('en-US', options);
    const day = currentDateTime.getDate();
    const month = currentDateTime.toLocaleString('en-US', { month: 'long' });
    const year = currentDateTime.getFullYear();

    return `${time} , ${day}${getDaySuffix(day)} ${month} ${year}`;
}

export const getTimestamp = () => {
    const now = new Date();
    const hh = String(now.getHours()).padStart(2, "0");
    const mm = String(now.getMinutes()).padStart(2, "0");
    const ss = String(now.getSeconds()).padStart(2, "0");

    const timestamp = hh + mm + ss;

    return timestamp;
}

const getDaySuffix = (day) => {
    if (day >= 11 && day <= 13) {
        return 'th';
    }
    switch (day % 10) {
        case 1:
            return 'st';
        case 2:
            return 'nd';
        case 3:
            return 'rd';
        default:
            return 'th';
    }
}

export const formatMessageTimestamp = (timestamp) => {
    if (!timestamp) return '';
    
    const messageDate = new Date(timestamp);
    const now = new Date();
    
    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const startOfYesterday = new Date(startOfToday);
    startOfYesterday.setDate(startOfYesterday.getDate() - 1);
    
    const startOfMessageDate = new Date(messageDate.getFullYear(), messageDate.getMonth(), messageDate.getDate());
    
    const timeString = messageDate.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    });
    
    if (startOfMessageDate.getTime() === startOfToday.getTime()) {
        return `Today, ${timeString}`;
    }
    
    if (startOfMessageDate.getTime() === startOfYesterday.getTime()) {
        return `Yesterday ${timeString}`;
    }
    
    const dateString = messageDate.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
    
    return `${dateString} ${timeString}`;
}